import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    search: {
      borderColor: theme.palette.neutralTertiary,
      ':hover': {
        borderColor: theme.palette.neutralSecondary,
      },
    },
    callout: {
      flexGrow: 1,
    },
    searchAreaContainer: {
      maxHeight: 400,
      padding: 10,
      width: 400,
      backgroundColor: theme.palette.neutralLighterAlt,
    },
    resultItem: {
      textDecoration: 'none',
      margin: '0px -20px',
      padding: '6px 20px',
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
      ':active': {
        backgroundColor: theme.palette.neutralLighter,
      },
    },
  };
});
